import { RootState } from '../../../app/store';
import { createSelector, createSlice, PayloadAction } from "@reduxjs/toolkit"
import SavedSearchModel from '../models/SavedSearchModel';
import _ from 'lodash';

interface SavedSearchState {
    savedSearches: SavedSearchModel[],
    loadedData: boolean,
    currentViewSavedSearch: SavedSearchModel[],
    selectedSavedSearch: SavedSearchModel | null,
    expanded: boolean
}

const initialState: SavedSearchState = {
    savedSearches: [],
    loadedData: false,
    currentViewSavedSearch: [],
    selectedSavedSearch: null,
    expanded: true
}

export const SavedSearchSlice = createSlice({
    name: "SavedSearch",
    initialState,
    reducers: {
        setSavedSearches: (state, action: PayloadAction<SavedSearchModel[]>) => {
            state.savedSearches = action.payload;
        },
        setLoadedSavedSearch: (state, action: PayloadAction<boolean>) => {
            state.loadedData = action.payload;
        },
        setCurrentViewSavedSearch: (state, action: PayloadAction<SavedSearchModel[]>) => {
            state.currentViewSavedSearch = action.payload;
        },
        addSavedSearch: (state, action: PayloadAction<SavedSearchModel>) => {
            state.currentViewSavedSearch = [action.payload, ...state.currentViewSavedSearch];
            state.savedSearches = [action.payload, ...state.savedSearches];
        },
        setSelectedSavedSearch: (state, action: PayloadAction<SavedSearchModel>) => {
            state.selectedSavedSearch = action.payload;
        },
        setSavedSearchExpanded: (state, action: PayloadAction<boolean>) => {
            state.expanded = action.payload;
        },
    }
});

export const savedSearchSelector = createSelector(
    (state: RootState) => state.savedSearchSelector,
    (data) => data
);

export const {
    setSavedSearches,
    setLoadedSavedSearch,
    setCurrentViewSavedSearch,
    addSavedSearch,
    setSelectedSavedSearch,
    setSavedSearchExpanded
} = SavedSearchSlice.actions;

export default SavedSearchSlice.reducer;